// Task runs API — TanStack Query hook

import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskRunListItem } from "../../../shared/types";

export function useRuns(brandId: string | undefined) {
  return useQuery({
    queryKey: ["task-runs", brandId],
    queryFn: () =>
      api.get<{ data: TaskRunListItem[] }>(
        `/api/task-runs?brand_id=${encodeURIComponent(brandId!)}&limit=50`,
      ),
    enabled: !!brandId,
  });
}
